var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-result"},[_c('result-head',{attrs:{"type":"success"}},[_vm._v("报名成功！")]),_c('group-result-main',{attrs:{"qrCode":_vm.qrCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }